// Owner: S6. The address of the data quality queue (`/data-quality?tab=…`). A light module, so the routes check
// the address without loading the page.
import { z } from 'zod';
import { QUALITY_TABS } from './tabs';

export const DataQualitySearch = z.object({
  tab: z.enum(QUALITY_TABS).optional().catch(undefined),
  // A record page links here with the record and field whose conflict to resolve. The queue does not narrow
  // to them (yet): they are kept so such links stay valid.
  record: z.uuid().optional().catch(undefined),
  field: z.string().max(63).optional().catch(undefined),
});
